export const storeConstants = {
    CREATE_SUCCESS: 'STORE_CREATE_SUCCESS',
    CREATE_FAILURE: 'STORE_CREATE_FAILURE',

    UPDATE_SUCCESS: 'STORE_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'STORE_UPDATE_FAILURE',

    DELETE_SUCCESS: 'STORE_DELETE_SUCCESS',
    DELETE_FAILURE: 'STORE_DELETE_FAILURE',

    GETONE_SUCCESS: 'STORE_GETONE_SUCCESS',
    GETONE_FAILURE: 'STORE_GETONE_FAILURE',

    GET_BYTOKEN_SUCCESS: 'STORE_GET_BYTOKEN_SUCCESS',
    GET_BYTOKEN_FAILURE: 'STORE_GET_BYTOKEN_SUCCESS',

    GETALL_SUCCESS: 'STORE_GETALL_SUCCESS',
    GETALL_FAILURE: 'STORE_GETALL_FAILURE',

    ACTIVE_SUCCESS: 'STORE_DELETE_SUCCESS',
    ACTIVE_FAILURE: 'STORE_DELETE_FAILURE',

    CLEAR: 'STORE_CLEAR_REDU',

    /** Use for web-checkin app*/
    TOGGER_PROFILE: 'STORE_TOGGER_PROFILE'
};
